import { TAModel } from './../model/TA.model';
import { map } from 'rxjs/operators';
import { AppConstant } from 'src/app/config/app.constant';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { APIs } from '../config/api.constant';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  adminDetails = new BehaviorSubject<TAModel>(null);
  constructor(private apiService: ApiService) { }

  getCoAdmins(): Observable<any> {
    const queryParam = {
      tenantId: Number(localStorage.getItem(AppConstant.localStorage.tenantId)),
    }
    return this.apiService.get(APIs.getCoAdmins, queryParam).pipe(map(response => {
      console.log('coadmins ', response);
      return response.list;
    }));
  }

  getAdminData() {
    const queryParam = {
      tenantId: Number(localStorage.getItem(AppConstant.localStorage.tenantId)),
    }
    return this.apiService.get(APIs.getAdminData, queryParam).pipe(map(response => {
      console.log('admins ', response);
      return response.data;
    }));
  }

  addEmployee(requestData): Observable<boolean> {
    const paramObj = {
      ...requestData
    }
    return this.apiService.post(APIs.addemployee, paramObj, '').pipe(map(response => {
      console.log('coadmins ', response);
      return response;
    }));
  }

  saveAdmin(requestData): Observable<boolean> {
    const paramObj = {
      ...requestData
    }
    return this.apiService.post(APIs.saveCoAdmin, paramObj, '').pipe(map(response => {
      console.log('coadmins ', response);
      return response;
    }));
  }

  updateAdmin(requestData): Observable<boolean> {
    const paramObj = {
      ...requestData
    }
    return this.apiService.put(APIs.updateCoAdmin, paramObj, '').pipe(map(response => {
      console.log('coadmins ', response);
      return response;
    }));
  }

  updateUserAccessPoint(userData): Observable<boolean> {
    const data = {
      accessPointList: userData.accessPointList,
      sendEmail: false,
      userId: userData.userId,
      AccessOperationType: userData.AccessOperationType
    };
    return this.apiService.post(APIs.updateUserAccessPoint, data, '').pipe(map(response => {
      return response;
    }));

  }

  getUserAccessPointList(id): Observable<any> {
    console.log('test ', new Date().getSeconds());

    const param = {
      id: id
    }
    return this.apiService.get(APIs.getUserAccessPoints, param).pipe(map(response => {
      return response;
    }))
  }

  getTenantSavedAccessPoints(id): Observable<any> {
    console.log('test ', new Date().getSeconds());

    const param = {
      tenantId: id
    }
    return this.apiService.get(APIs.getTenantSavedAccessPoints, param).pipe(map(response => {
      return response;
    }))
  }

  removeCoAdmin(id): Observable<any> {
    const param = {
      id: id
    }
    return this.apiService.delete(APIs.removeCoAdmin, param).pipe(map(response => {
      return response;
    }))
  }


  getTenantOverview() {
    return this.apiService.get(APIs.getOverviewTenant + '/' + localStorage.getItem(AppConstant.localStorage.tenantId)).pipe(map(response => {
      return response.data;
    }))
  }

  getTenantMoreDetails() {
    return this.apiService.get(APIs.getTenantOtherDetails + '/' + localStorage.getItem(AppConstant.localStorage.tenantId)).pipe(map(response => {
      return response.data;
    }))
  }

  // forgotPasswordPortal(email) {
  //   return this.apiService.get(APIs.forgotPasswordPortal, { Email: email }).pipe(map(response => {
  //     return response;
  //   }))
  // }

  forgotPasswordPortal(email) {
    return this.apiService.post(APIs.changeActivation, { Email: email }).pipe(map(response => {
      return response;
    }))
  }

  GetUserData() {
    return this.apiService.get(APIs.user, {}).pipe(map(response => {
      return response;
    }))
  }


  changeActivation(activationStatus: boolean, userId: number): Observable<any> {
    return this.apiService.post(APIs.changeActivation, { userId: userId, isActive: activationStatus }).pipe(map(response => {
      return response;
    }))
  }

  getadmindetails() {
    return this.apiService.get(APIs.getadmindetails, {}).pipe(map(response => {

      return response;
    }))
  }

  getParkiteAdmin() {
    return this.apiService.get(APIs.getParkiteAdmin, {}).pipe(map(response => {

      return response;
    }))
  }

  updatePassword(payload: { password: string, oldPassword: string, token: string }): Observable<any> {
    return this.apiService.put(APIs.updatePassword, '', null, payload).pipe(map(response => {
      return response;
    }))
  }

  // resetPwd(payload: { password: string, token: string }) {
  // return this.apiService.put(APIs.resetPassword, '', null, payload).pipe(map(response => {
  // return response;
  //}))
  // }

  resetPwd(password, token, email) {
    console.log(email)
    const header = {
      Authorization: token,
    };
    const paramobj = {
      password: password,
      token: token,
      emailid: email
    };
    return this.apiService.put(APIs.resetPassword, paramobj, header).pipe(map(response => {
      return response;
    }))
  }

  changePassword(payload: { password: string, oldPassword: string, token: string }): Observable<any> {
    return this.apiService.put(APIs.updatePassword, '', null, payload).pipe(map(response => {
      return response;
    }))
  }

  getSavedAdminDetails() {
    return this.adminDetails.asObservable();
  }
  setAdminDetails(details) {
    this.adminDetails.next(details)
  }
}
